import { II18n } from '../../../../../models';
import { I18nService } from '../../../../../services';
import React from 'react';

const translations: II18n = {
  es: {
    relationalSubGroup: 'Seleccionar subgrupo de contexto',
  },
  enUS: {
    relationalSubGroup: 'Select context subgroup',
  },
  ptBR: {
    relationalSubGroup: 'Selecione o sub grupo de contexto',
  },
};

const translate = (key: string, args?: string[]): string =>
  new I18nService(translations).translate(key, args);

export { translate };
